import CategoryInfoCard from './CategoryInfoCard'

export default CategoryInfoCard
